import { render, staticRenderFns } from "./EhrIndexPage.vue?vue&type=template&id=f23482ba"
import script from "./EhrIndexPage.vue?vue&type=script&lang=js"
export * from "./EhrIndexPage.vue?vue&type=script&lang=js"
import style0 from "./EhrIndexPage.vue?vue&type=style&index=0&id=f23482ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports